import(/* webpackMode: "eager" */ "/app/src/app/widerruf/page.tsx");
